var _rect, _line, _path, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSampleCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    id: "buildings",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    x2: 240,
    y1: 215.983,
    y2: 215.983,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M143.99414 215.98316v-176a8 8 0 0 0-8-8h-96a8 8 0 0 0-8 8v176M223.99414 215.98316v-112a8 8 0 0 0-8-8h-72"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 63.994,
    x2: 95.994,
    y1: 71.983,
    y2: 71.983,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 79.994,
    x2: 111.994,
    y1: 135.983,
    y2: 135.983,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 63.994,
    x2: 95.994,
    y1: 175.983,
    y2: 175.983,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 175.994,
    x2: 191.994,
    y1: 175.983,
    y2: 175.983,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 175.994,
    x2: 191.994,
    y1: 135.983,
    y2: 135.983,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleCompany);
export default __webpack_public_path__ + "static/media/sampleCompany.5a10100fb3561ab62e90fdce6fde96d5.svg";
export { ForwardRef as ReactComponent };